<template>
  <div class="marketing-plan-table">
    <button v-if="manage"
            class="marketing-plan-table-add btn text-primary"
            @click="emitAddPlan">
      <i class="mdi mdi-plus"></i> {{$t('message.marketingPlan.message.addPlan')}}
    </button>
    <v-data-table class="marketing-plan-table-body"
                  :headers="headers"
                  :items="plansList"
                  :loading="loading"
                  :hide-actions="true"
                  :no-data-text="$t('message.marketingPlan.message.noPlansRegistered')"
                  :no-results-text="$t('message.generics.message.noData')">

      <template slot="items"
                slot-scope="props">
        <marketing-plan-table-item :planItem="props.item"
                                   :value="value"
                                   :manage="manage"
                                   @change="setSelectedId"
                                   @deleted="emitChanged"
                                   @edited="emitChanged" />
      </template>
    </v-data-table>

    <marketing-plan-add-form v-model="showPlanAddForm"
                             @back="hidePlanAddForm"
                             @added="hidePlanAddForm" />
  </div>
</template>

<script>
import MarketingPlanAddForm from "@components/modules/marketing/plan/add/form/MarketingPlanAddForm";
import MarketingPlanTableItem from "@components/modules/marketing/plan/table/item/MarketingPlanTableItem";

export default {
  components: {
    MarketingPlanAddForm,
    MarketingPlanTableItem,
  },
  data() {
    return {
      page: 0,
      showPlanAddForm: false,
    };
  },

  computed: {
    headers() {
      return [
        { text: "", value: "", sortable: false, width: 50 },
        {
          text: this.$t("message.generics.message.name"),
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("message.marketingPlan.message.smsAmount"),
          value: "smsAmount",
          sortable: false,
        },
        {
          text: this.$t("message.marketingPlan.message.emailAmount"),
          value: "emailAmount",
          sortable: false,
        },
        // { text: this.$t('message.marketingPlan.message.whatsAppAmount'), value: "whatsAppAmount", sortable: false },
        { text: "", value: "", sortable: false },
      ];
    },
  },

  props: {
    plansList: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    value: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    manage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitAddPlan() {
      this.$emit("addPlan");

      this.showPlanAddForm = true;
    },
    setSelectedId(value) {
      if (value.selected) {
        return this.$emit("input", value.id);
      }

      this.$emit("input", undefined);
    },
    hidePlanAddForm() {
      this.showPlanAddForm = false;

      this.$emit("cancelAddPlan");
    },
    emitChanged() {
      this.$emit("changed");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-plan-table {
  margin: 30px 0 15px;

  .marketing-plan-table-add {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: $primary;
    padding-right: 0;
    box-shadow: none;
    font-size: 12px;
  }

  .marketing-plan-table-body {
    padding: 0 20px 10px;
    border: 2px solid #c4c4c4;
    border-radius: 8px;
  }
}
</style>
